
import React, { useState, useEffect } from 'react';
import { Navbar, Nav } from 'react-bootstrap'
import { useHistory } from "react-router-dom";
import AuthService from "../controllers/AuthService";

const NavigationBar = () => {
    const [currentUser, setCurrentUser] = useState(undefined);
    const history = useHistory();

    useEffect(() => {
        const user = AuthService.getCurrentUser();
        if (user) {
            setCurrentUser(user);
        }
    }, []);

    const logOut = () => {
        AuthService.logout();
    };

    return (
        <div>
            <Navbar collapseOnSelect expand="lg" className="nav-color" variant="dark">
                <Navbar.Toggle aria-controls="responsive-navbar-nav" className="white-text" >
                </Navbar.Toggle>
                <Navbar.Brand className="logo">
                    <div className="d-none d-lg-block">
                        <a href="/" ><img src='/images/icons/mm-logo-desktop.png' width="210" />
                        </a></div>
                    <div className="d-block d-lg-none text-center">
                        <a href="/"><img src='/images/icons/mm-logo-mobile.png' width="125" /></a>
                    </div>
                </Navbar.Brand>
                <Navbar.Collapse id="responsive-navbar-nav">
                    {currentUser ? (
                        <Nav className="ml-auto menu">
                            <Nav.Link href="https://in-school.mindsetmaker.co/24-character-strengths" className="submenu">24 Character Strengths</Nav.Link>
                            <Nav.Link href="/activity" className="submenu">Strength School</Nav.Link>
                            <Nav.Link href="/report" className="submenu">รายงาน </Nav.Link>
                            <Nav.Link href="https://www.mindsetmaker.co/about/" className="submenu">เกี่ยวกับเรา</Nav.Link>
                            <Nav.Link href="https://www.mindsetmaker.co/" className="submenu">For Happiness</Nav.Link>
                            <Nav.Link href="/login" className="submenu" onClick={logOut}>ออกจากระบบ</Nav.Link>
                        </Nav>
                    ) : (
                        <Nav className="ml-auto menu">
                            <Nav.Link href="https://in-school.mindsetmaker.co/24-character-strengths/" className="submenu">24 Character Strengths</Nav.Link>
                            <Nav.Link href="/activity" className="submenu">Strength School</Nav.Link>
                            <Nav.Link href="/login" className="submenu">รายงาน </Nav.Link>
                            <Nav.Link href="https://www.mindsetmaker.co/about/" className="submenu">เกี่ยวกับเรา</Nav.Link>
                            <Nav.Link href="https://www.mindsetmaker.co/" className="submenu">For Happiness</Nav.Link>
                            <Nav.Link href="/login" className="submenu">เข้าสู่ระบบ</Nav.Link>
                        </Nav>
                    )}
                </Navbar.Collapse>
            </Navbar>
        </div>
    )
}

export default NavigationBar